import React from "react";
import { useNavigate } from "react-router-dom";
import { FormattedMessage, useIntl } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

type CommonFormHeaderProps = {
  title?: React.ReactNode;
  className?: string;
  actions?: React.ReactNode;
};

export const CommonFormHeader: React.FC<CommonFormHeaderProps> = ({
  title,
  className,
  actions,
}) => {
  const intl = useIntl();
  const navigate = useNavigate();

  return (
    <div className={`bg-white rounded-xl p-5 mb-6 border border-gray-200 shadow-sm ${className || ""}`}>
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <button
            onClick={() => navigate(-1)}
            className="p-2.5 rounded-xl border border-gray-200 hover:bg-gray-50 transition-colors text-gray-600 hover:text-gray-800"
            title={intl.formatMessage({ id: "BACK", defaultMessage: "Back" })}
          >
            <FontAwesomeIcon icon={faArrowLeft} className="h-4 w-4" />
          </button>
          <h1 className="text-xl font-semibold text-gray-800">
            {title || (
              <FormattedMessage id="COMMON.FORM.HEADER.DEFAULT" defaultMessage="Form" />
            )}
          </h1>
        </div>
        {actions && <div className="flex items-center gap-2">{actions}</div>}
      </div>
    </div>
  );
};

export default CommonFormHeader;

